import { useBoolFlag } from '../components';
import { Undefinable } from '../types';
import { useSwitchAwareConfig } from './use-config';

export const useAllowedRoutes = (portal: string): string[] | null => {
  const config = useSwitchAwareConfig();
  const isEnabled = useBoolFlag('portals-restrict-route-access-based-on-domain-configuration');
  if (isEnabled === false) return null;

  const allowedRoutes = config.portals?.[portal]?.allowedRoutes as Undefinable<string[]>;

  return allowedRoutes ?? null;
};
